import { Entity, Network } from '../../types';

export enum NetworkTopicState {
  ENGAGE = 'ENGAGE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  VIVA = 'VIVA',
  YAMMER = 'YAMMER',
}

export interface CurrentNetwork extends Entity {
  readonly permalink: string;
  readonly isLegacyExternalNetwork: boolean;
  readonly isOfficeTopicsEnabled: boolean;
  readonly isNativeModeSharePointOnlyFileStorage: boolean;
  readonly isTranslationEnabled: boolean;
  readonly isWebPushNotificationsEnabled: boolean;
  readonly isForcedNotificationEnabled: boolean;
  readonly isDirectMessagesEnabled: boolean;
  readonly isDraftPostsEnabled: boolean;
  readonly networkTopicsState?: NetworkTopicState;
}

export type NormalizedCurrentNetwork = CurrentNetwork & Network;
